import { api, formatApiErrorDetail } from "./api";

export async function listPackages() {
  try {
    const { data } = await api.get("/billing/packages");
    return { ok: true, data };
  } catch (e) {
    return { ok: false, message: formatApiErrorDetail(e.response?.data?.detail) };
  }
}

export async function listPlans() {
  try {
    const { data } = await api.get("/billing/plans");
    return { ok: true, data };
  } catch (e) {
    return { ok: false, message: formatApiErrorDetail(e.response?.data?.detail) };
  }
}

/**
 * Returns `{ mode: "test"|"live", publishable_key_prefix }` so the UI can
 * conditionally render the TEST badge. Server reads STRIPE_API_KEY and only
 * returns the prefix — never the key itself.
 */
export async function getStripeConfig() {
  try {
    const { data } = await api.get("/billing/stripe/config");
    return { ok: true, data };
  } catch (e) {
    return { ok: false, message: formatApiErrorDetail(e.response?.data?.detail) };
  }
}

/**
 * Create a Stripe Checkout Session. Server-side is the source of truth for
 * amounts — the client only sends the target key + its window.location.origin.
 * Response: { session_id, url } — call sites should `window.location.href = url`.
 */
export async function createCheckout({ target, originUrl }) {
  try {
    const { data } = await api.post("/billing/checkout", {
      target,
      origin_url: originUrl,
    });
    return { ok: true, data };
  } catch (e) {
    return {
      ok: false,
      status: e.response?.status,
      body: e.response?.data,
      message: formatApiErrorDetail(e.response?.data?.detail) || e.message,
    };
  }
}

/**
 * Poll the checkout session status after redirect back. Unauthenticated —
 * session_id itself is the token. Returns { session_id, status, payment_status,
 * target, amount_total, currency, credited }.
 */
export async function getCheckoutStatus(sessionId) {
  try {
    const { data } = await api.get(`/billing/checkout/status/${sessionId}`);
    return { ok: true, data };
  } catch (e) {
    return {
      ok: false,
      status: e.response?.status,
      message: formatApiErrorDetail(e.response?.data?.detail) || e.message,
    };
  }
}

/** Utility credit endpoint — keep for internal tests / manual NXT grants. */
export async function creditMock(body) {
  try {
    const { data } = await api.post("/billing/credit", body);
    return { ok: true, data };
  } catch (e) {
    return {
      ok: false,
      status: e.response?.status,
      message: formatApiErrorDetail(e.response?.data?.detail) || e.message,
    };
  }
}

export async function listPaymentsHistory(page = 1, pageSize = 20) {
  try {
    const { data } = await api.get("/billing/history", { params: { page, page_size: pageSize } });
    return { ok: true, data };
  } catch (e) {
    return { ok: false, message: formatApiErrorDetail(e.response?.data?.detail) };
  }
}

// Format price from cents to a friendly string
export function formatPrice(cents, currency = "usd") {
  const symbol = currency === "usd" ? "$" : "";
  return `${symbol}${(cents / 100).toFixed(2)}`;
}
